import { RootState } from "../../../redux-store";

export const selectStatus = (state: RootState) => state.app.connection.status;
